import type { FC } from "react";

import { Button } from "src/components";
import { RICH_TEXT_COMPONENTS, Trans, useTranslation } from "src/translations";

type QuestionnaireInfoProps = {
    onStart: () => void;
};

export const QuestionnaireInfo: FC<QuestionnaireInfoProps> = ({ onStart }) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-6">
            <p className="text-xl font-semibold">{t("verification.INVESTOR_QUESTIONNAIRE.info.title")}</p>

            <div className="prose prose-sm">
                <Trans i18nKey="verification.INVESTOR_QUESTIONNAIRE.info.text" components={RICH_TEXT_COMPONENTS} />
            </div>

            <Button type="button" onClick={onStart} className="self-start">
                {t("verification.INVESTOR_QUESTIONNAIRE.info.buttonText")}
            </Button>
        </div>
    );
};
